<template>
    <div class="modal-backdrop" @click="closeModal">
        <v-container>
            <v-row class="d-flex justify-center">
                <v-col cols="12" xl="6" md="6" xs="6">
                    <ValidationObserver v-slot="{ invalid }">
                        <v-form ref="form" v-model="valid" @submit.prevent="validateAndSubmit">
                            <div @click.stop>
                                <v-card>
                                    <CardHeader :title="title" :icon="icon" color="primary" variant="gradient"></CardHeader>

                                    <v-card-text>
                                        <div v-for="(field, index) in fields" :key="index">
                                            <ValidationProvider :name="field.label" :rules="field.rules"
                                                v-slot="{ errors }">
                                                <v-text-field 
                                                    v-model="data[field.model]" 
                                                    :label="field.label"
                                                    :error-messages="errors" 
                                                    outlined 
                                                    dense 
                                                    required>
                                                </v-text-field>
                                            </ValidationProvider>
                                        </div>
                                    </v-card-text>

                                    <v-card-actions class="justify-end">
                                        <div class="mb-3">
                                            <custom-button 
                                                class="ma-1" 
                                                type="submit" 
                                                :disabled="invalid" 
                                                label="등록"
                                                color="primary" 
                                                size="md" 
                                                gradient 
                                                rounded>
                                            </custom-button>
                                            <custom-button 
                                                class="ma-1" 
                                                @click="closeModal" 
                                                label="닫기" 
                                                color="black"
                                                size="md" 
                                                gradient 
                                                rounded>
                                            </custom-button>
                                        </div>
                                    </v-card-actions>
                                </v-card>
                            </div>
                        </v-form>
                    </ValidationObserver>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import CardHeader from '../cards/CardHeader.vue';
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import { required, numeric } from "vee-validate/dist/rules";
import CustomButton from '@/components/common/buttons/CustomButton.vue';

extend("required", {
    ...required,
    message: "{_field_}을(를) 입력하세요."
});
extend("numeric", {
    ...numeric,
    message: "숫자를 입력하세요."
});

export default {
    name: "AddTextForm",
    components: {
        CustomButton,
        CardHeader,
        ValidationObserver,
        ValidationProvider,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            required: false,
            default: "mdi-playlist-plus"
        },
        fields: {
            type: Array,
            required: true,
            default: () => [],
        },
        value: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            data: { ...this.value },
        };
    },
    methods: {
        closeModal() {
            this.$emit("close");
        },
        async validateAndSubmit() {
            const isValid = await this.$refs.form.validate();
            if (isValid) {
                this.changeData();
            }
        },
        changeData() {
            if (this.data.idx === null) {
                this.$emit('save-data', this.data);
            } else {
                this.$emit('change-data', this.data);
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
}
</style>
